import { SET_IS_EDIT_MODE } from '../actionConstants';

export const setIsEditModeAction = (payload) => {
  return {
    type: SET_IS_EDIT_MODE,
    payload,
  };
};
